// extracted by mini-css-extract-plugin
export default {"question":"n4TryXNjcERLpL2Iw4OB"};